export default __webpack_public_path__ + "static/media/6.95c636fb.svg";